import { ChangeControl } from '../../types/changeControl';

export const isChangeControlOwner = (changeControl: ChangeControl, currentUserId: number): boolean =>
  !changeControl.createdBy || String(currentUserId) === changeControl.createdBy.id;
